const initialState = {
  loading: false,
  goodsList: [],
  query: {
    page: 1,
    limit: 9,
    state: '1'
  },
  total: 0,
  sortTypeActive: 0,
  sortTypes: [
    {
      name: '综合排序',
      query: {
        shopType: 4,
      }
    },
    {
      name: '价格从低到高',
      query: {
        sortType: 'asc',
        sortKey: 'min_price'
      }
    },
    {
      name: '价格从高到低',
      query: {
        sortType: 'desc',
        sortKey: 'min_price'
      }
    },
  
  ]
};

function reducer(state, action) {
  switch (action.type) {
    case 'setLoading':
      return { ...state, loading: action.payload };
    case 'setGoodsList':
      return { ...state, goodsList: action.payload };
    case 'setQuery':
      return { ...state, query: action.payload };
    case 'setTotal':
      return { ...state, total: action.payload };
    case 'setSortTypeActive':
      return { ...state, sortTypeActive: action.payload };
    default:
  }
}

const setLoading = payload => ({
  type: 'setLoading',
  payload,
});

const setGoodsList = payload => ({
  type: 'setGoodsList',
  payload,
});

const setQuery = payload => ({
  type: 'setQuery',
  payload,
});

const setTotal = payload => ({
  type: 'setTotal',
  payload,
});

const setSortTypeActive = payload => ({
  type: 'setSortTypeActive',
  payload,
});

export {
  initialState,
  reducer,
  setLoading,
  setGoodsList,
  setQuery,
  setTotal,
  setSortTypeActive
};
